import {Component, Inject, OnInit, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {NgIf, NgOptimizedImage} from '@angular/common';
import {TitanButtonComponent} from '../../../user-interface/titan-button/titan-button.component';
import {Subject, takeUntil} from 'rxjs';

export interface ModalData {
  title: string,
  content: string,
  icon?: string,
  image?: string,
  buttonText?: string,
  primaryButtonFunction?: () => Promise<void>,
  primaryButtonText?: string,
  actionText?: string,
  isExecutingAction$?: Subject<boolean>
}

@Component({
  selector: 'app-sp-modal-info',
  standalone: true,
  imports: [
    MatIconModule,
    NgOptimizedImage,
    NgIf,
    TitanButtonComponent
  ],
  templateUrl: './sp-modal-info.component.html'
})

export class SpModalInfoComponent implements OnInit, OnDestroy {
  title = '';
  textContent = '';
  icon = '';
  image = '';
  buttonText = 'Close';
  primaryButtonFunction?: () => Promise<void>;
  primaryButtonText = '';
  actionText = '';
  isExecutingAction = false;

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<SpModalInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
  ) { }

  ngOnInit(): void {
    this.title = this.data.title;
    this.textContent = this.data.content;
    this.icon = this.data.icon;
    this.image = this.data.image;
    if (this.data.buttonText) { this.buttonText = this.data.buttonText; }
    this.primaryButtonFunction = this.data.primaryButtonFunction;
    if (this.data.primaryButtonText) { this.primaryButtonText = this.data.primaryButtonText; }
    if (this.data.actionText) { this.actionText = this.data.actionText; }

    // Subscribe to exporting state changes if provided
    if (this.data.isExecutingAction$) {
      this.data.isExecutingAction$
        .pipe(takeUntil(this.destroy$))
        .subscribe(isExporting => {
          this.isExecutingAction = isExporting;
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async onPrimaryButtonClick(): Promise<void> {
    if (this.primaryButtonFunction && !this.isExecutingAction) {
      await this.primaryButtonFunction();
    }
  }

  get currentPrimaryButtonText(): string {
    return this.isExecutingAction ? this.actionText : this.primaryButtonText;
  }
}
